import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../index';
import { addDirectorsAction, addDirectorsDetails, AddonSlug, ObjectiveSlug } from './types';

type InitialStateOnboarding = {
  legal_personality: string;
  objectives: ObjectiveSlug[];
  number_of_director: number;
  is_corporate_director: boolean;
  value_corporate_director: number;
  directors: addDirectorsDetails[];
  shareholders: number;
  underages: number;
  addons: AddonSlug[];
  listAddons: string[];
  entityOptions: { id: string; label: string } | undefined; 
  jurisdictions: { id: string | number; label: string } | undefined; 
  // Campos para renovação anual
  annual_renewal_corporate_director: boolean;
  annual_renewal_corporate_director_value: number;
};

const initialStateOnboarding: InitialStateOnboarding = {
  legal_personality: '',
  objectives: [],
  number_of_director: 1,
  is_corporate_director: false,
  value_corporate_director: 0,
  directors: [],
  shareholders: 1,
  underages: 0,
  addons: [],
  listAddons: [],
  entityOptions: undefined,
  jurisdictions: undefined,
  annual_renewal_corporate_director: false,
  annual_renewal_corporate_director_value: 0,
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState: initialStateOnboarding,
  reducers: {
    addLegalPersonality: (state: any, action: PayloadAction<string>) => {
      if (action.payload) {
        state.legal_personality = action.payload;
      }
    },
    addObjectives: (state: any, action: PayloadAction<string[]>) => {
      if (action.payload) {
        const adapterAddObjectives = action.payload.map((objective: string) => ({ objective_slug: objective }));
        state.objectives = adapterAddObjectives;
      }
    },
    addDirectors: (state: any, action: PayloadAction<addDirectorsAction>) => {
      const { is_corporate_director, number_of_director, value_corporate_director } = action.payload;

      state.number_of_director = number_of_director;
      state.is_corporate_director = is_corporate_director;
      state.value_corporate_director = value_corporate_director;
    },
    saveDirectors: (state: any, action: PayloadAction<any>) => {
      if (action.payload) {
        state.directors = action.payload
      }
    },
    addShareholders: (state: any, action: PayloadAction<number>) => {
      state.shareholders = action.payload;
    },
    addAddons: (state: any, action: PayloadAction<any>) => {
      if (action.payload) {
        const adapterAddAddons = action.payload.filter((addon: string) => { if (addon) { return {addon_slug: addon} }});

        state.addons = adapterAddAddons;
      }
    },
    saveAddons: (state: any, action: PayloadAction<any>) => {
      if (action.payload) {
        state.listAddons = action.payload;
      }
    },
    addEntityOptions: (state: any, action: PayloadAction<{ id: string; label: string }>) => {
      state.entityOptions = action.payload;
    },
    addJurisdictions: (state: any, action: PayloadAction<{ id: string | number;  label: string}>) => {
      state.jurisdictions = action.payload;
    },
    addAnnualRenewalCorporateDirector: (state: any, action: PayloadAction<{ is_corporate_director: boolean; value: number }>) => {
      const { is_corporate_director, value } = action.payload;
      state.annual_renewal_corporate_director = is_corporate_director;
      state.annual_renewal_corporate_director_value = value;
    },
    resetOnboarding: (state) => {
      // Reseta o campo de shareholders explicitamente junto com outros valores
      return {
        ...initialStateOnboarding,
      };
    }
  }
});

export const { addLegalPersonality, addObjectives, addDirectors, saveDirectors, addShareholders,addAddons, saveAddons, addEntityOptions, addJurisdictions, addAnnualRenewalCorporateDirector, resetOnboarding  } =
  onboardingSlice.actions;
export const onboardingSelector = (state: RootState) => state.onboarding;
export default onboardingSlice.reducer;
